import { render, staticRenderFns } from "./LanguagesView.vue?vue&type=template&id=0ed40ab2&scoped=true"
import script from "./LanguagesView.vue?vue&type=script&lang=ts"
export * from "./LanguagesView.vue?vue&type=script&lang=ts"
import style0 from "./LanguagesView.vue?vue&type=style&index=0&id=0ed40ab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed40ab2",
  null
  
)

export default component.exports